import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
    topBarStyles: {
        fontWeight: 500,
        display: 'block',
    },
    notificationsContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    popoverPaper: {
        width: 500,
        padding: 16, // Equivalent to padding: 2
        maxHeight: 600,
        overflow: "hidden",
    },
    headerTypography: {
        fontWeight: 600,
    },
    hamburgButton: {
        "&:hover": { borderRadius: "50%" },
        minWidth: "10px !important",
    },
    hamburgPopoverContent: {
        padding: 16,
    },
    optionLink: {
        fontWeight: 500,
        display: 'block',
        lineHeight: "30px",
        cursor: "pointer",
        '&:hover': { textDecoration: 'underline' }
    },
    emptyStateContainer: {
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        height: 550,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    notificationsList: {
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        height: 550,
        overflowY: "auto",
    },
    listItemPrimaryBox: {
        fontSize: "12px",
        fontWeight: 600,
    },
    listItemText: {
        "& .MuiTypography-root": {
            textTransform: "capitalize",
        },
        paddingRight: "15px",
    },
    listItemSecondaryBox: {
        display: "flex",
        flexDirection: "column",
        gap: 4, // Equivalent to gap: 0.5
        marginTop: 8, // Equivalent to mt: 1
    },
    notificationBody: {
        wordBreak: 'break-word',
    },
    reviewLink: {
        fontWeight: 500,
        display: 'block',
        textTransform: "capitalize",
        textDecoration: 'none',
        color: theme.palette.primary.main,
    },
    timestamp: {
        textTransform: 'lowercase',
    },
    severityIcon: {
        padding: "5px",
        border: "1px solid transparent",
        "&:hover": {
            borderColor: "lightgray",
        },
    },
    popoverContent: {
        padding: '10px',
        fontSize: '13px',
        wordBreak: 'break-word',
        color: '#333',
    },
    readStatusIcon: {
        padding: "5px",
        border: "1px solid transparent",
        "&:hover": {
            borderColor: "lightgray",
        },
    },
    loadingText: {
        textAlign: "center",
        paddingY: 8, // Equivalent to py: 1
        color: "gray",
        fontSize: 13,
    },
    gridMargin: {
        marginBottom: "10px",
    },
    alignCenter: {
        alignContent: "center",
    },
    warningIcon: {
        color: "orange",
        fontSize: "12px",
    },
    errorIcon: {
        color: "red",
        fontSize: "12px",
    },
    successIcon: {
        color: "green",
        fontSize: "12px",
    },
    statusCircleIcon: {
        fontSize: "12px",
    },
    toasterHeader: {
        fontWeight: 600,
        textTransform: 'capitalize',
        fontSize: '11px',
    },
    toasterTitle: {
        fontWeight: 600,
        textTransform: 'capitalize',
    },
    toasterBody: {
        fontSize: '12px',
    }
}));

export default useStyles;
